import { useCallback, useState, useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'

import A from 'utils/metrics/analytic'
import GTAG from 'utils/metrics/gtagMethods'
import PopupWrapperNew from 'containers/popup-wrapper-new/popup-wrapper-new'
import Loader from 'components/parts/loader/loader'
import RegistrationCode from '../registration/registration-code/registration-code'

const AnketaWebinar = dynamic(
  () => import('components/fullscreen-popups/registration/anketa-webinar/anketa-webinar'),
  {
    loading: () => (
      <div className={styles.loaderWrapper}>
        <Loader modificator={styles.loaderMod} />
      </div>
    ),
  }
)
import Auth from 'store/auth'
import useActivePopupStatus from 'store/common/useActivePopupStatus'
import useTitle from 'store/common/useTitle'

import { YaMetricHit } from 'utils/metrics/analyticMethods'
import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'
import { AdditionPageTitle, TransitionEvent } from './data'
import { Pathname } from 'constants/data'

import styles from './hash-popup.module.scss'

let isBottom = false

const HashPopup = () => {
  const { isAuthorized, isFilledUser } = Auth.useAuth()
  const { hashPopupStatus, setHashPopupStatus } = useActivePopupStatus()
  const { setPageTitle } = useTitle()
  const router = useRouter()
  const [component, setComponent] = useState<React.ReactElement | null>(null)

  const path = cutHashFromURL(router.asPath)
  const isMedpulsePage = path.endsWith(Pathname.MEDPULSE)

  const handleClose = useCallback(() => {
    hashPopupStatus && setHashPopupStatus()
    router.replace(path, undefined, { shallow: true, scroll: false })
  }, [])

  const currentPop = useMemo(() => {
    let content = null
    isBottom = false
    if (hashPopupStatus === popupName.registration) {
      isBottom = true
      content = <RegistrationCode handleClose={handleClose} />
    } else if (hashPopupStatus === popupName.anketaWebinar && isAuthorized && !isFilledUser) {
      isBottom = true
      content = <AnketaWebinar handleClose={handleClose} />
    }
    return content
  }, [handleClose, hashPopupStatus, isAuthorized, isFilledUser])

  useEffect(() => {
    const isContent = Boolean(currentPop)
    if (isContent) {
      A.setEvent(TransitionEvent[hashPopupStatus as keyof typeof TransitionEvent])
    }
    const nextPopupStatus =
      (isContent && AdditionPageTitle[hashPopupStatus as keyof typeof AdditionPageTitle]) || ''

    setPageTitle(nextPopupStatus)
    GTAG.pageview(window.location.href)
    YaMetricHit(window.location.href)

    setComponent(currentPop)
  }, [hashPopupStatus, isAuthorized, handleClose, isFilledUser, currentPop, setPageTitle])

  const isComponentActive = Boolean(hashPopupStatus) && Boolean(component)

  if (!isComponentActive) return null

  return (
    <PopupWrapperNew
      popupBlockMod={styles.popupHelper}
      bgNoClicked
      isBottom={isBottom}
      isPopupScrollPosition={!isMedpulsePage}
      closePopup={handleClose}
    >
      {component}
    </PopupWrapperNew>
  )
}

export default HashPopup
